import { userAPI } from '@/services-ts/axios'
import type { IPayloadCompanySetting } from '@/types/Request'
import type { IPositionStore } from '@/types/Store/State'
import { Format } from '@/utils-ts'
import { defineStore } from 'pinia'
import {
  createSimpleListItem,
  deleteSimpleListItem,
  fetchSimpleList,
  updateSimpleListItem,
} from './simpleListHelpers'

export const usePositionStore = defineStore('position', {
  state: (): IPositionStore => ({
    positionList: [],
  }),

  actions: {
    async GetPositionList() {
      const list = await fetchSimpleList(() => userAPI.PositionServices.GetPositionList())
      if (list) this.positionList = list
    },

    async CreatePosition(Name: string) {
      const item = await createSimpleListItem(
        name => userAPI.PositionServices.CreatePosition(name),
        Name,
        Format('admin_components_company_position_positioncreated'),
      )
      if (item) this.positionList.push(item)
      return !!item
    },

    async UpdatePosition(payload: IPayloadCompanySetting) {
      const status = await updateSimpleListItem(
        p => userAPI.PositionServices.UpdatePosition(p),
        payload,
      )
      if (status) {
        this.positionList = this.positionList.map(position =>
          position.id === payload.Id
            ? { ...position, name: payload.Name, firstValue: payload.Name }
            : position,
        )
      }
      return status
    },

    async DeletePosition(Id: string) {
      const status = await deleteSimpleListItem(
        id => userAPI.PositionServices.DeletePosition(id),
        Id,
      )
      if (status) {
        this.positionList = this.positionList.filter(position => position.id !== Id)
      }
    },
  },
})
